import React from 'react'

const PlusIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<path d="M3.33331 8H12.6666" stroke="#FFCC03" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M8 3.33301V12.6663" stroke="#FFCC03" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
  )
}

export default PlusIcon